/** Doctor Details */

'use strict'

$(document).ready(function () {
  // Education Carousel - Slick Initialization
  $('.profile-education__carousel').slick({
    centerMode: false,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    prevArrow: $('.slick__prev--profile-education'),
    nextArrow: $('.slick__next--profile-education'),
    adaptiveHeight: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          centerMode: false,
          dots: false,
          arrows: true,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });


  // Navigation Scrollspy  
  let sections = {};
  $('section').each((_, e) => {
    sections[e.id] = e.offsetTop - 32;
  });

  $(window).scroll(function () {
    for (let key in sections) {
      if ($(window).scrollTop() >= sections[key]) {
        $('.nav-menu__item').removeClass('active');
        $(`.nav-menu__item[href="#${key}"]`).addClass('active');
      }
    }
  });

  $(window).bind('scroll load', function () {
    if ($(this).scrollTop() < 350) {
      $('.appointment').addClass('not-scrolled');
      $('.appointment').removeClass('scrolled');
      $('.appointment__detail-address').removeClass('d-none');
      $('.appointment__detail-address').addClass('d-block');
      $('.appointment__detail-profile').removeClass('d-block');
      $('.appointment__detail-profile').addClass('d-none');
      $('.appointment__detail').css({
        'align-items': 'flex-start',
        'text-align': 'left'
      });
      $('.appointment').css({
        'opacity': '1',
        'visibility': 'visible'
      });
    }
    if ($(this).scrollTop() > 350) {
      $('.appointment').removeClass('not-scrolled');
      $('.appointment').addClass('scrolled');
      $('.appointment__detail-address').removeClass('d-block');
      $('.appointment__detail-address').addClass('d-none');
      $('.appointment__detail-profile').removeClass('d-none');
      $('.appointment__detail-profile').addClass('d-block');
      $('.appointment__detail').css({
        'align-items': 'center',
        'text-align': 'center'
      });
      $('.appointment').css({
        'opacity': '1',
        'visibility': 'visible'
      });
    }
    if ($(this).scrollTop() > $('main.doctor-detail').height()) {
      $('.appointment').css({
        'opacity': '0',
        'visibility': 'hidden'
      });
    }
  });
});